import LinearAnimatedBackground from './linearAnimatedBackground';

export default LinearAnimatedBackground;
